import { Text } from '@chakra-ui/react';

function HeaderPreview({ formValues: rawFormValues }: PreviewComponentProps) {
  const formValues = rawFormValues as ContentContainer;
  return (
    <Text variant="h2" w="100%">
      {formValues?.title || 'tu pojawi się Twój nagłówek'}
    </Text>
  );
}

export default HeaderPreview;
